import getUserRole, { canEditClientContent } from "../../utils/getRoleToken";

const CONDITION_TYPE_MANAGER_ROLES = new Set([
  "gestor",
  "admin",
  "administrador",
  "aipim",
  "setup",
]);

export function canManageConditionTypeExclusions() {
  const role = String(getUserRole() || "").toLowerCase();
  return CONDITION_TYPE_MANAGER_ROLES.has(role) && canEditClientContent();
}
